import React, { useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Chip,
    CircularProgress,
    Divider,
    Grid,
    Typography,
    Box,
    TextField,
} from '@mui/material';
import { get, map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Table from '../../../components/form/TableDetail';
import { getInvoiceClientListDTE } from '../../../store/transactions/thunk/invoiceClient/getListDTE';
import { getInvoiceClientListDteReset } from '../../../store/transactions/actions/invoiceClient/getListDTE';

const LabelValue = ({ label, children }) => (
    <Box>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Box sx={{ mt: 0.5 }}>{children}</Box>
    </Box>
);

const headTable = [
    { key: 'create_date',    label: 'create_date',       align: 'center' },
    { key: 'name',           label: 'Documento #',        align: 'center' },
    { key: 'amount_total',   label: 'Monto',              align: 'right'  },
    { key: 'state',          label: 'Documento Estado',   align: 'center' },
    { key: 'payment_state',  label: 'Pago Estado',        align: 'center' },
];

const DteModal = ({ open, onClose, invoiceId }) => {
    const [__] = useTranslation('invoiceClient');
    const dispatch = useDispatch();
    const listDTE = useSelector((state) => state.transactions.invoiceClient.listDTE);

    useEffect(() => {
        if (open && invoiceId) {
            dispatch(getInvoiceClientListDTE({ InvoiceId: invoiceId }));
        }
        if (!open) {
            dispatch(getInvoiceClientListDteReset());
        }
    }, [open, invoiceId]);

    const rawData     = get(listDTE, 'data');
    const firstRecord = Array.isArray(rawData) ? (rawData[0] ?? {}) : (rawData ?? {});

    const transmitido = get(firstRecord, 'transmitidoErp', '');
    const isOk        = transmitido?.toUpperCase() === 'OK';
    const chipColor   = isOk ? '#03BE06' : '#ff0000';

    const dataTable = map(get(firstRecord, 'datosFacturacion', []), (row) => ({
        create_date:   get(row, 'create_date') ? moment(get(row, 'create_date')).format('DD/MM/YYYY') : '-',
        name:          get(row, 'name', '-'),
        amount_total:  get(row, 'amount_total') != null ? `$${Number(get(row, 'amount_total')).toFixed(2)}` : '-',
        state:         get(row, 'state', '-'),
        payment_state: get(row, 'payment_state', '-'),
    }));

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Detalle Transmisión Odoo</DialogTitle>
            <Divider />
            <DialogContent>
                {get(listDTE, 'isLoading') ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                        <CircularProgress color="secondary" />
                    </Box>
                ) : (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} md={3}>
                            <LabelValue label="Oddo Status">
                                {transmitido ? (
                                    <Chip
                                        label={transmitido}
                                        size="small"
                                        sx={{ bgcolor: `${chipColor}26`, color: chipColor, fontWeight: 600 }}
                                    />
                                ) : (
                                    <Typography variant="body2">-</Typography>
                                )}
                            </LabelValue>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Mensaje ERP"
                                value={get(firstRecord, 'mensajeErp', '')}
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                InputProps={{ readOnly: true }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4} md={3}>
                            <LabelValue label="Oddo Interno">
                                <Typography variant="body2">
                                    {get(firstRecord, 'odooSOInternal') ?? '-'}
                                </Typography>
                            </LabelValue>
                        </Grid>
                        <Grid item xs={12} sm={8} md={9}>
                            <LabelValue label="Oddo SO">
                                <Typography variant="body2">
                                    {get(firstRecord, 'odooSOname') || '-'}
                                </Typography>
                            </LabelValue>
                        </Grid>

                        <Grid item xs={12}>
                            <Table
                                headTable={headTable}
                                dataTable={dataTable}
                                __={__}
                                loading={get(listDTE, 'isLoading', false)}
                                empty="tableDetalle"
                            />
                        </Grid>
                    </Grid>
                )}
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={onClose}>Aceptar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DteModal;
